<template lang="pug">
  .layout
    y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px")
      v-card
        v-card-title.px-4.h6.basic800--text {{ $t('custom_domain_settings') }}
        v-divider.basic300
        v-card.pa-0(flat)
          v-layout.my-6(v-if="isFetching")
            v-row.fill-height.ma-0(align='center' justify='center')
              v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
          div(v-else)
            div.pa-4(v-if="activeDomain")
              .c1.primary400--text {{ $t('use_domain') }}
                strong &nbsp;{{activeDomain.name}}&nbsp;
                | on:
              v-row.mt-4(no-gutters)
                v-col
                  .s1.basic1000--text {{ $t('whatsapp_form') }}
                  .c1.primary400--text wasap.{{ activeDomain.name }}
                v-col.shrink
                  y-switch.my-auto.mr-n2(v-model="checkbox" :value="1")
              v-row.mt-4(no-gutters)
                v-col
                  .s1.basic1000--text Yezza Store
                v-col.shrink
                  y-switch.my-auto.mr-n2(v-model="checkbox" :value="2")
            div.pa-4(v-if="pendingDomain")
              p.p1.primary400--text {{ $t('request_text_1') }}
                strong  {{ pendingDomain.name }}
                |  {{ $t('request_text_2') }}
              p.p1.primary400--text {{ $t('request_text_3') }}
            div.pa-4(v-if="requestForm")
              v-form(ref="form" )
                .s1.basic800--text {{ $t('request_custom_domain') }}
                .c1.primary400--text {{ $t('request_custom_domain_text') }}
                .label.basic600--text.text-uppercase.mt-6 {{ $t('domain.name') }}
                v-text-field.mt-2(v-model='domain_name' outlined dense persistent-hint counter :placeholder="$t('domain.placeholder')" :maxlength="50" :rules="rules.not_empty" background-color="basic200")
                .inventory.d-flex
                  y-checkbox.my-auto.mx-0.pa-0(v-model="hasDomain" hide-details)
                    template(v-slot:label)
                      div.p1.my-auto {{ $t('domain.own') }}
        v-card-actions
          v-spacer
          v-btn(color='white', text @click='showModal = false')
            .button-Aa-small.primary400--text {{ $t('cancel') }}
          v-btn.mr-2(v-if="requestForm" color='info500' dark depressed height=32 @click="clickSend" :loading="isLoading")
            .button-AA-small.basic100--text {{ $t('send') }}
          v-btn.mr-2(v-if="activeDomain" color='info500' dark depressed height=32 @click="clickSave" :loading="isLoading")
            .button-AA-small.basic100--text {{ $t('save') }}
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'RequestCustomDomain',
  props: ['open', 'settings', 'company'],
  data: () => ({
    isFetching: false,
    domain_name: null,
    hasDomain: false,
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required']
    },
    requestForm: false,
    checkbox: [],
    activeDomain: null,
    pendingDomain: null,
    isLoading: false
  }),
  watch: {
    domain_name (val) {
      this.domain_name = val.toLowerCase()
    },
    activeDomain (val) {
      this.checkbox = val.mode
    }
  },
  computed: {
    ...mapState('user', ['member']),
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    ownDomain () {
      return this.hasDomain ? 'Yes' : 'No'
    }
  },
  mounted () {
    this.loadDomain()
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    checkDomain (domain) {
      var re = new RegExp(/^((?:(?:(?:\w[.\-+]?)*)\w)+)((?:(?:(?:\w[.\-+]?){0,62})\w)+)\.(\w{2,6})$/)
      return domain.match(re)
    },
    loadDomain() {
      this.isFetching = true
      this.$axios.get(`/domains/?company=${this.company.id}`)
        .then((response) => {
          let domains = response.data.results
          if(domains.length > 0) {
            this.requestForm = false
            this.activeDomain = domains.filter((domain)=>{return domain.enabled}).pop()
            this.pendingDomain = domains.filter((domain)=>{return !domain.enabled}).pop()
          } else {
            this.requestForm = true
          }
        })
        .catch(() =>{
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetching = false
        })
    },
    clickSave() {
      let data = {
        mode: this.checkbox
      }
      this.isLoading = true
      this.$axios.patch(`/domains/${this.activeDomain.id}/`, data)
        .then(() => {
          this.showModal = false
        })
        .catch(() =>{
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    clickSend() {
     
      if (!this.$refs.form.validate()) {
        return
      }
      if (!this.checkDomain(this.domain_name)) {
        this.showMessage(['error', this.$t('error_message.please_enter_valid_domain')])
        return
      }
      this.isLoading = true
      let data = {
          name: this.domain_name,
          company: this.company.id,
          note: this.hasDomain ? "Already has domain": "No domain yet"
      }
      this.$axios.post(`/domains/`, data)
        .then(() => {
          this.showMessage(['info', this.$t('info_message.domain_request_sent')])
          this.showModal = false
        })
        .catch(() =>{
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "custom_domain_settings": "Custom Domain Settings",
    "use_domain": "Use domain",
    "whatsapp_form": "WhatsApp Form",
    "request_text_1": "Your request for custom domain",
    "request_text_2": "is being processed.",
    "request_text_3": "Kindly check your email or WhatsApp to check on your requested custom domain status in 1 working days.",
    "request_custom_domain": "Request custom domain",
    "request_custom_domain_text": "Request custom domain through our tech support. We will contact back to you ASAP.",
    "domain": {
      "name": "Desired domain name",
      "placeholder": "eg: arbatravel.com",
      "own": "Do you already own the domain?"
    }
  },
  "id": {
    "custom_domain_settings": "Pengaturan Domain Khusus",
    "use_domain": "Guna Domain",
    "whatsapp_form": "WhatsApp Form",
    "request_text_1": "Permintaan kamu untuk domain khusus",
    "request_text_2": "sedang dalam proses.",
    "request_text_3": "Silakan periksa email atau WhatsApp kamu untuk memeriksa status domain khusus yang kamu minta dalam 1 hari kerja.",
    "request_custom_domain": "Minta Domain Khusus",
    "request_custom_domain_text": "Minta domain khusus melalui dukungan teknis kami. Kami akan menghubungi kamu kembali secepatnya.",
    "domain": {
      "name": "Domain Khusus yand diminta",
      "placeholder": "eg: arbatravel.com",
      "own": "Apakah kamu sudah memiliki domain??"
    }
  }
}
</i18n>
